export const calcDayNightCycle = (sunrise?: string, sunset?: string): 'Day' | 'Night' => {
  if (!sunrise || !sunset) return 'Day'

  const curTime = new Date().toLocaleString('en-US', { hour12: false, timeStyle: 'medium' })
  const riseTime = new Date(sunrise).toLocaleString('en-US', { hour12: false, timeStyle: 'medium' })
  const setTime = new Date(sunset).toLocaleString('en-US', { hour12: false, timeStyle: 'medium' })

  return curTime < riseTime || curTime >= setTime ? 'Night' : 'Day'
}
